class Places {

    static Eilat =  () => { return 'אילת' ;}

    static DeadSea =  () => { return 'ים המלח' ;}

    static LowerGalilee =  () => { return 'גליל תחתון' ;}

    static UpperGalilee =  () => { return 'גליל עליון' ;}

    static WestGalilee =  () => { return 'גליל מערבי' ;}

    static Kineret =  () => { return 'אזור הכנרת' ;}

    static Merchaz =  () => { return 'אזור המרכז' ;}

    static Jerusalem =  () => { return 'ירושלים' ;}

    static Hasharon =  () => { return 'השרון' ;}

    static Darom =  () => { return 'אזור דרום' ;}


}


export default Places;